import { createClient } from '@supabase/supabase-js';

//const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
//const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
//console.log(import.meta.env.VITE_SUPABASE_URL)
//export const supabase = createClient(supabaseUrl, supabaseAnonKey); 

export const supabase = createClient('https://ctjzwoumfvkavicuhhnw.supabase.co', 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN0anp3b3VtZnZrYXZpY3VoaG53Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTE4MDM1OTIsImV4cCI6MjA2NzM3OTU5Mn0._q50s8TJ6YD1Osmep9ymRj1oeT4VibznhXYFmY07KTI'); 